namespace GeniuzPOS.Purchase {
    export interface ReportPurTaxData extends Serenity.ListRequest {
        Details?: ReportPurTaxRow[];
        Year?: string;
        Monthh?: string;
        BizName?: string;
        ShopName?: string;
        ShopAddress?: string;
        ShopTaxId?: string;
        BranchName?: string;
    }
}
